var map = L.map('map', {
  gestureHandling: true
}).setView([lat || 50.605, lon || 8.09], 8);
L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    maxZoom: 18,
    id: 'meurologic/ckwk7opwv4uuh14ns5cmjn937',
    tileSize: 512,
    zoomOffset: -1,
    accessToken: 'pk.eyJ1IjoibWV1cm9sb2dpYyIsImEiOiJja3drMTgxYjUwZXJ0Mm9tdHA1bHB1bDM1In0.DTr2E5HdTHaQx3SpwxW3SQ'
}).addTo(map);

var markerIcon = L.icon({
    iconUrl: '/images/map-icon-1.png',
    shadowUrl: '/images/map-icon-1_shadow.png',
    iconSize:     [32, 32], // size of the icon
    shadowSize:   [32, 32], // size of the shadow
    iconAnchor:   [16, 32], // point of the icon which will correspond to marker's location
    shadowAnchor: [0, 32],  // the same for the shadow
    popupAnchor:  [-3, -32] // point from which the popup should open relative to the iconAnchor
});
var markerIcon2 = L.icon({
    iconUrl: '/images/map-icon-2.png',
    shadowUrl: '/images/map-icon-1_shadow.png',
    iconSize:     [48, 48], // size of the icon
    shadowSize:   [48, 48], // size of the shadow
    iconAnchor:   [24, 48], // point of the icon which will correspond to marker's location
    shadowAnchor: [0, 48],  // the same for the shadow
    popupAnchor:  [-3, -48] // point from which the popup should open relative to the iconAnchor
});
var markers = L.markerClusterGroup();
var singleMarker = L.layerGroup();


$(document).ready(function() {
  if (lat !== undefined && lon) {
    singleMarker.addLayer(L.marker([lat, lon], {icon: markerIcon2 }));
  }
  $.each(services, (i, service) => {
    if (service.lat && service.lon) {
      if (i == 0) {
        // map.setView([service.lat, service.lon], 9);
      }
      markers.addLayer(L.marker([service.lat, service.lon], {icon: markerIcon}).bindPopup(`<a class="service-popup-link popup-link btn btn-sm btn-link c3" href="/angebot/${service.id}">${service.name}</a><br>`));

    }
  });
  map.addLayer(markers);
  map.addLayer(singleMarker);
});
